export const questions = [
  {
    id: 'question-1',
    text: 'Wie alt sind Sie?',
    options: [
      '25-35 Jahre',
      '36-45 Jahre',
      '46-55 Jahre',
      '56-65 Jahre',
      'Über 65 Jahre'
    ]
  },
  {
    id: 'question-2',
    text: 'Was ist Ihr größtes Hautproblem?',
    options: [
      'Falten und Linien',
      'Trockenheit und Elastizitätsverlust',
      'Unregelmäßiger Teint',
      'Empfindliche Haut',
      'Mehrere der genannten Probleme'
    ]
  },
  {
    id: 'question-4',
    text: 'Wie zufrieden sind Sie mit Ihrem aktuellen Hautzustand?',
    options: [
      'Sehr zufrieden',
      'Ziemlich zufrieden',
      'Neutral',
      'Unzufrieden',
      'Sehr unzufrieden'
    ]
  },
  {
    id: 'question-5',
    text: 'Welche Problemzonen bereiten Ihnen die meisten Sorgen?',
    options: [
      'Gesicht (Gesamtzustand)',
      'Augenbereich',
      'Hals und Dekolleté',
      'Hände',
      'Mehrere Bereiche'
    ]
  },
  {
    id: 'question-7',
    text: 'Wie würden Sie Ihren Lebensstil beschreiben?',
    options: [
      'Sehr aktiv und sportlich',
      'Moderat aktiv',
      'Meist sitzend',
      'Stressig und hektisch',
      'Ausgewogen'
    ]
  },
  {
    id: 'question-8',
    text: 'Welche Hautpflege verwenden Sie aktuell?',
    options: [
      'Keine regelmäßige Pflege',
      'Basis-Pflege (Reinigung + Creme)',
      'Erweiterte Pflege (Seren, Masken)',
      'Professionelle Produkte',
      'Verschiedene Produkte im Wechsel'
    ]
  },
  {
    id: 'question-9',
    text: 'Haben Sie bereits Erfahrung mit Nahrungsergänzungsmitteln für die Haut?',
    options: [
      'Nein, noch nie',
      'Ja, aber ohne spürbare Wirkung',
      'Ja, mit mäßigem Erfolg',
      'Ja, mit gutem Erfolg',
      'Ja, aber suche nach Verbesserung'
    ]
  },
  {
    id: 'question-11',
    text: 'Was ist Ihr Hauptziel für Ihre Haut?',
    options: [
      'Prävention von Hautalterung',
      'Verbesserung der Hautstruktur',
      'Straffung und Elastizität',
      'Ausgeglichener Teint',
      'Allgemeine Hautgesundheit'
    ]
  },
  {
    id: 'question-12',
    text: 'In welchem Zeitraum möchten Sie erste Ergebnisse sehen?',
    options: [
      'Sofort',
      'Innerhalb von 2 Wochen',
      'Innerhalb von 1 Monat',
      'Innerhalb von 3 Monaten',
      'Langfristige Verbesserung'
    ]
  },
  {
    id: 'question-13',
    text: 'Wie wichtig ist Ihnen eine tägliche Hautpflege-Routine?',
    options: [
      'Sehr wichtig',
      'Wichtig',
      'Mäßig wichtig',
      'Nicht so wichtig',
      'Unwichtig'
    ]
  },
  {
    id: 'question-15',
    text: 'Was ist Ihr Budget für Hautpflege-Produkte?',
    options: [
      'Unter 50€ pro Monat',
      '50-100€ pro Monat',
      '100-200€ pro Monat',
      'Über 200€ pro Monat',
      'Flexibel je nach Produkt'
    ]
  },
  {
    id: 'question-16',
    text: 'Was motiviert Sie am meisten, sich um Ihre Haut zu kümmern?',
    options: [
      'Selbstbewusstsein',
      'Gesundheit',
      'Äußeres Erscheinungsbild',
      'Langanhaltende Jugendlichkeit',
      'Professionelle Empfehlung'
    ]
  },
  {
    id: 'question-17',
    text: 'Wie würden Sie Ihren Alltag beschreiben?',
    options: [
      'Viel Zeit im Freien',
      'Meist in klimatisierten Räumen',
      'Wechselnd zwischen drinnen und draußen',
      'Viel Stress und wenig Schlaf',
      'Ausgewogen und regelmäßig'
    ]
  },
  {
    id: 'question-19',
    text: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihre personalisierte Analyse zu erhalten:',
    type: 'email',
    placeholder: 'ihre@email.de'
  }
]; 